import { render, staticRenderFns } from "./NatConIndividualAwardEdit.vue?vue&type=template&id=61163aa2"
import script from "./NatConIndividualAwardEdit.vue?vue&type=script&lang=js"
export * from "./NatConIndividualAwardEdit.vue?vue&type=script&lang=js"
import style0 from "./NatConIndividualAwardEdit.vue?vue&type=style&index=0&id=61163aa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports